import type { FunctionComponent } from 'react'
import React from 'react'
import { Button, Modal } from '@arvoreeducacao/bonsai-ds'
import { usePlayerContext } from 'context/player'
import { useTranslation } from 'i18n'
import { EXPLORE_PATH } from 'routes/paths'

import * as S from './ModalPreviewLimit.styles'

const PREVIEW_IMAGE_URL =
  'https://cdn.arvore.com.br/files.arvoredelivros.com.br/arvore-library-assets/images/reader-web/biblion-preview-empty.png'

const ModalPreviewLimit: FunctionComponent = () => {
  const { t } = useTranslation()
  const {
    state: { hasReachedPreviewLimit, slug }
  } = usePlayerContext()

  if (!hasReachedPreviewLimit) return null

  const title = t('Gostou de ouvir?')

  const handleBorrow = () => {
    if (!slug) return
    window.location.href = `/app-v2/book/intermediate/${slug}`
  }

  const handleBackToCatalog = () => {
    window.location.href = EXPLORE_PATH
  }

  return (
    <Modal
      title={title}
      isOpen={true}
      type="standard"
      size="small"
      onClose={handleBackToCatalog}
      titleSize={4}
      center
      sheetHeaderProps={{
        title,
        type: 'close'
      }}
      portalContainer={document.getElementById('modal')}
    >
      <S.Wrapper>
        <S.Illustration src={PREVIEW_IMAGE_URL} alt="" />
        <S.Description>
          {t(
            'Você chegou ao limite da prévia. Para continuar ouvindo, pegue este livro emprestado.'
          )}
        </S.Description>
        <S.Actions>
          <Button
            theme={{ type: 'primaryLivros', size: 'large' }}
            text={t('Pegar emprestado')}
            fluid
            onClick={handleBorrow}
          />
          <Button
            theme={{ type: 'secondary', size: 'large' }}
            text={t('Voltar ao catálogo')}
            fluid
            onClick={handleBackToCatalog}
          />
        </S.Actions>
      </S.Wrapper>
    </Modal>
  )
}

export default ModalPreviewLimit
